import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Navbar as BsNavbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { FaUser, FaCog, FaSignOutAlt, FaBuilding, FaHome } from 'react-icons/fa';
import { logout } from '../../redux/slices/authSlice';
import styles from './Navbar.module.css';

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.auth.user);
  const { t } = useTranslation();
  // const role = user?.role;
  // const officeOwner = user?.officeOwner;

  const handleLogout = () => {
    dispatch(logout());
    console.log('Logging out');
    navigate('/login');
  };

  return (
    <BsNavbar bg="white" expand="lg" className={styles.navbar}>
      <Container fluid>
        <BsNavbar.Brand 
          className={styles.brand}
          onClick={() => navigate('/dashboard')}
          style={{ cursor: 'pointer' }}
        >
          PensionPlus {user?.role === 'OFFICE' ? `- ${user?.officeOwner}` : ''}
        </BsNavbar.Brand>
        
        <Nav className="ms-auto" style={{ alignItems: 'center', flexDirection: 'row' }}>
          <Nav.Item 
            onClick={() => navigate('/dashboard')}
            className={styles.homeIcon}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '0.5rem 1rem' }}
          >
            <FaHome style={{ fontSize: '1.2rem' }} />
          </Nav.Item>
          <NavDropdown
            title={user?.username}
            align="end"
            className={styles.userDropdown}
          >
            <NavDropdown.Item onClick={() => navigate('/profile')}>
              <FaUser className="me-2" />
              {t('navbar.profile')}
            </NavDropdown.Item>

            {/* <NavDropdown.Item onClick={() => navigate('/settings')}>
              <FaCog className="me-2" />
              Settings
            </NavDropdown.Item> */}
            
            {(user?.role === 'ADMIN' || user?.role === 'STAFF' || user?.role === 'OWNER') && (
              <NavDropdown.Item onClick={() => navigate('/offices')}>
                <FaBuilding className="me-2" />
                {t('navbar.offices')}
              </NavDropdown.Item>
            )}
            <NavDropdown.Divider />

            <NavDropdown.Item onClick={handleLogout}>
              <FaSignOutAlt className="me-2" />
              {t('navbar.logout')}
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Container>
    </BsNavbar>
  );
};

export default Navbar; 